import { Dispatch } from 'react';
import {
  DirectDebitDetails,
  InsuranceJourneyPaymentDetailsType
} from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const PaymentPageEventHandlers = (
  paymentDetails: InsuranceJourneyPaymentDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeDirectDebitDetails: (value: DirectDebitDetails) => {
      dispatch({
        type: 'set-payment-details',
        paymentDetails: { ...paymentDetails, directDebitDetails: value }
      });
    },
    setCardPaymentDetails: (value: string) => {
      dispatch({
        type: 'set-payment-details',
        paymentDetails: {
          ...paymentDetails,
          cardPaymentDetails: {
            ...paymentDetails.cardPaymentDetails,
            transactionId: value
          }
        }
      });
    }
  };
};
